export enum GameRoundQueryKeys {
  Primary = '/game-rounds',
  Tiles = '/game-rounds/tiles',
  BySlug = '/game-rounds/slug/:slug',
  ByGameId = '/game-rounds/game/:gameId',
}
